import { render, staticRenderFns } from "./vodShare.vue?vue&type=template&id=c0b9051e"
import script from "./vodShare.vue?vue&type=script&lang=js"
export * from "./vodShare.vue?vue&type=script&lang=js"
import style0 from "./vodShare.vue?vue&type=style&index=0&id=c0b9051e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports